import { render, staticRenderFns } from "./SamThreeColumnImage.vue?vue&type=template&id=9b00a16e&scoped=true&"
import script from "./SamThreeColumnImage.vue?vue&type=script&lang=js&"
export * from "./SamThreeColumnImage.vue?vue&type=script&lang=js&"
import style0 from "./SamThreeColumnImage.vue?vue&type=style&index=0&id=9b00a16e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b00a16e",
  null
  
)

export default component.exports